import React from 'react';
import styled from 'styled-components';

import { Container, Grid, Typography } from '@material-ui/core';

import EinsparPotentialBeispielKundenCard from '../components/cards/einsparpotentialBeispielkunden-card';
import LastgangHochladenCard from '../components/cards/CardUploadLoadProfile';
import CardWrapper from '../components/common/CardWrapper';

const Root = styled.div`
	h1 {
		font-size: 24px;
		font-weight: bold;
	}
`;

const PageHome = () => (
	<Root>
		<Container maxWidth="lg">
			<Grid container>
				<Grid item xs={12}>
					<CardWrapper>
						<Typography variant="h1">metis.light</Typography>
					</CardWrapper>
				</Grid>
				<Grid item xs={12}>
					<LastgangHochladenCard />
				</Grid>
				<Grid item xs={12}>
					<EinsparPotentialBeispielKundenCard />
				</Grid>
			</Grid>
		</Container>
	</Root>
);

export default PageHome;
